(function() {
  'use strict';

  // Horren24 levertijd-component (1 bron van waarheid op de productpagina).
  // Toont per geselecteerde variant exact EEN levertijd-regel net boven de ATC:
  //   1. variant out-of-stock bij Hamstra  -> amber  "Levertijd: ca. 2 weken ..."
  //   2. product getagd Levertijd:2-5werkdagen -> neutraal "Levertijd: 2 tot 5 werkdagen"
  //   3. anders (in-stock raamhor)          -> groene countdown naar 13:00
  // OOS wint altijd van de tag. Het tegenstrijdige statische "dezelfde dag
  // verzonden"-blok in de product-sectie wordt verborgen (footer blijft intact).
  //
  // Data komt uit sectie h24_levertijd_data: window.h24Delivery = {
  //   tagged25: bool, oosByVariant: { "<variantId>": "<tekst>", ... } }.

  // Only run on product pages. Selectors voor zowel oudere als nieuwere Horizon
  // (theme-update jun 2026 verving product-information/product-form door
  // product-form-component/add-to-cart-component).
  if (!document.querySelector('[data-product-form]') &&
      !document.querySelector('product-information') &&
      !document.querySelector('product-form-component') &&
      !document.querySelector('[name="add"]')) return;

  var data = (window.h24Delivery && typeof window.h24Delivery === 'object') ? window.h24Delivery : {};
  var oosMap = (data.oosByVariant && typeof data.oosByVariant === 'object') ? data.oosByVariant : {};
  var tagged25 = !!data.tagged25;

  var CLOCK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="__C__" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>';
  var TRUCK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="__C__" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>';

  function findTarget() {
    return document.querySelector('.product-information__add-to-cart') ||
           document.querySelector('product-form-component') ||
           document.querySelector('product-form') ||
           document.querySelector('.product-form-buttons') ||
           (document.querySelector('[name="add"]') &&
            document.querySelector('[name="add"]').closest('.buy-buttons-block, .product-form-buttons, form, div'));
  }

  function currentVariantId() {
    var idInput = document.querySelector('form [name="id"], [name="id"]');
    if (idInput && idInput.value) return String(idInput.value);
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  var countdownTimer = null;

  function clearOurEls() {
    ['h24-delivery-banner', 'h24-countdown'].forEach(function(id) {
      var e = document.getElementById(id); if (e) e.remove();
    });
    if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
  }

  // Verberg het statische "dezelfde dag verzonden"-blok BINNEN de product-sectie
  // (niet document-breed; footer/header-statements blijven staan). Idempotent.
  function hideStatic() {
    var add = document.querySelector('[name="add"]');
    var scope = (add && add.closest('main')) ||
                document.querySelector('product-information') || document;
    var nodes = scope.querySelectorAll('p, li, span, div');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.children.length === 0 &&
          /dezelfde dag verzonden/i.test(n.textContent) &&
          !n.closest('footer, header, [class*="footer"], [class*="header"]')) {
        if (!n.hasAttribute('data-h24-hidden')) {
          n.setAttribute('data-h24-hidden', '1');
          n.style.display = 'none';
        }
      }
    }
  }

  function showBanner(text, kind) {
    clearOurEls();
    hideStatic();
    var target = findTarget();
    if (!target) return;
    var s = (kind === 'oos')
      ? { bg: '#fffbeb', bd: '#fde68a', fg: '#92400e', icon: CLOCK }
      : { bg: '#eff6ff', bd: '#bfdbfe', fg: '#1e40af', icon: TRUCK };
    var el = document.createElement('div');
    el.id = 'h24-delivery-banner';
    el.setAttribute('data-kind', kind);
    el.style.cssText = 'padding:8px 12px;margin:8px 0 12px;border-radius:8px;background:' + s.bg + ';border:1px solid ' + s.bd + ';font-size:0.875rem;color:' + s.fg + ';display:flex;align-items:center;gap:8px;';
    el.innerHTML = s.icon.replace(/__C__/g, s.fg);
    var span = document.createElement('span');
    span.textContent = text; // textContent = geen HTML-injectie
    el.appendChild(span);
    target.parentNode.insertBefore(el, target);
  }

  function showCountdown() {
    clearOurEls();
    hideStatic();
    var target = findTarget();
    if (!target) return;

    var el = document.createElement('div');
    el.id = 'h24-countdown';
    el.style.cssText = 'padding:8px 12px;margin:8px 0 12px;border-radius:8px;background:#f0fdf4;border:1px solid #bbf7d0;font-size:0.875rem;color:#166534;display:flex;align-items:center;gap:8px;';
    var icon = TRUCK.replace(/__C__/g, '#166534');

    function update() {
      var now = new Date();
      var amsterdam = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
      var hours = amsterdam.getHours();
      var minutes = amsterdam.getMinutes();
      if (hours < 13) {
        var remainH = 12 - hours;
        var remainM = 59 - minutes;
        if (remainM === 59) { remainH++; remainM = 0; }
        var timeStr = '';
        if (remainH > 0) timeStr += remainH + ' uur ';
        timeStr += remainM + ' min';
        el.innerHTML = icon + '<span>Bestel binnen <strong>' + timeStr + '</strong> voor verzending vandaag</span>';
      } else {
        el.innerHTML = icon + '<span>Na 13:00 besteld? Verzending op de eerstvolgende werkdag</span>';
      }
      el.style.display = 'flex';
    }

    target.parentNode.insertBefore(el, target);
    update();
    countdownTimer = setInterval(update, 30000);
  }

  var lastVid = null;

  function render(force) {
    var vid = currentVariantId();
    var haveEl = document.getElementById('h24-delivery-banner') || document.getElementById('h24-countdown');
    if (!force && vid === lastVid && haveEl) return; // niets veranderd
    lastVid = vid;
    var oosText = (vid && oosMap[vid]) ? oosMap[vid] : null;
    if (oosText) showBanner(oosText, 'oos');
    else if (tagged25) showBanner('Levertijd: 2 tot 5 werkdagen', 'tagged');
    else showCountdown();
  }

  // render() is idempotent: no-op als de variant niet veranderd is EN onze regel
  // er al staat. Korte poll (~2s): Horizon hydrateert/vervangt het bestelblok soms
  // NA onze eerste render, en werkt bij een variantwissel de verborgen variant-id
  // bij via een property (geen node-wissel). Beide worden zo alsnog opgepikt.
  function scheduleRender() {
    var tries = 0;
    var iv = setInterval(function() {
      render(false);
      if (++tries >= 20) clearInterval(iv); // ~2s
    }, 100);
  }

  render(true);
  scheduleRender();

  document.addEventListener('change', scheduleRender, true);
  document.addEventListener('click', scheduleRender, true);
  window.addEventListener('popstate', scheduleRender);

  // Observeer een STABIELE ancestor (body): Horizon kan het bestelblok volledig
  // vervangen, dus dat element zelf observeren is te fragiel.
  if (window.MutationObserver) {
    new MutationObserver(function() { render(false); }).observe(document.body, { childList: true, subtree: true });
  }
})();
